export * from './tab-group';
export { MdInkBar } from './ink-bar';
export { MdTabBody } from './tab-body';
export { MdTabHeader } from './tab-header';
export { MdTabLabelWrapper } from './tab-label-wrapper';
export { MdTab } from './tab';
export { MdTabLabel } from './tab-label';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/@angular/material/tabs/index.js
// module id = ../../../material/tabs/index.js
// module chunks = 3